import { ImmutableStore } from 'fluxible-immutable-utils';
import Actions from '../constants/Actions';
import FormState from '../constants/FormState';

const defaultState = {
  validDomain: false,
  formState: FormState.INITIAL
};

class SignUpStore extends ImmutableStore {
  static storeName = 'SignUpStore';

  static handlers = {
    [Actions.CLIENT_ACCOUNT__DOMAIN_VALIDATION_COMPLETED]: 'setDomainValid',
    [Actions.CLIENT_ACCOUNT__ACCOUNT_CREATED]: 'signUpComplete',
    [Actions.CLIENT_ACCOUNT__ACCOUNT_CREATION_STARTED]: 'signUpProcessing',
    [Actions.CLIENT_ACCOUNT__SIGNUP_FORM_RESET]: 'setDefaultState'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.setState(defaultState);
  }

  setDomainValid(validDomain) {
    this.mergeState({
      validDomain
    });
  }

  signUpComplete({success}) {
    if (!success) {
      this.mergeState({
        formState: FormState.ERROR
      });
    } else {
      this.mergeState({
        formState: FormState.COMPLETED
      });
    }
  }

  signUpProcessing() {
    this.mergeState({
      formState: FormState.PROCESSING
    });
  }

  setDefaultState() {
    this.setState(defaultState);
  }

  validDomain() {
    this.get('validDomain');
  }

  getFormState() {
    return this.get('formState');
  }
}

export default SignUpStore;



// WEBPACK FOOTER //
// ./src/stores/SignUpStore.js